<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="de01"></a><a id="page_iv"></a><i>I dedicate this book to my grandniece Aurora Ahern Carlsen,<br/> whose gift of light opens my heart.</i></p>
<div class="pagebreak">
<p class="cpytxt1">First Sentient Publications edition 2009</p>
<p class="cpytxt1">Copyright © 2009 by Adrianne Ahern, PhD</p>
<p class="cpytxt1">All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission, except in the case of brief quotations embodied in critical articles and reviews.</p>
<p class="cpytxt1">A paperback original</p>
<p class="cpytxt1">Cover design by Blair O’Neil</p>
<p class="cpytxt">Cover photo by Blair O’Neil</p>
<p class="cpytxt">Book design by Timm Bryson</p>
<p class="cpytxt1">Library of Congress Cataloging-in-Publication Data</p>
<p class="cpytxt1">Ahern, Adrianne, 1960–</p>
<p class="cpytxt">Back in charge : A guide to harnessing the magic of your brain to create the life you’ll love / Adrianne Ahern.</p>
<p class="cpytxt">p. cm.</p>
<p class="cpytxt">ISBN 978-1-59181-190-9</p>
<p class="cpytxt">1. Mind and body. 2. Self-perception. 3. Self-actualization (Psychology)</p>
<p class="cpytxt">I. Title.</p>
<p class="cpytxt">BF161.A34 2009</p>
<p class="cpytxt">158.1--dc22</p>
<p class="cpytxt">2009000762</p>
<p class="cpytxt2">10 9 8 7 6 5 4 3 2 1</p>
<p class="cpytxt3">SENTIENT PUBLICATIONS</p>
<p class="cpytxt">A Limited Liability Company</p>
<p class="cpytxt">1113 Spruce Street</p>
<p class="cpytxt">Boulder, CO 80302</p>
<p class="cpytxt"><a href="http://www.sentientpublications.com" target="_blank">www.sentientpublications.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?34e87493